<template>
  <div class="characteristic flex-box">
    <div class="characteristic-title">安全、可信、持续创新的产品与服务</div>
    <div class="characteristic-description">有效缩短产品研发周期、改善产品服务的设计迭代流程、降低产品研发成本</div>
    <div class="tab-container">
      <mobile-tab-fold :tabs="tabList" :value="activeName" @input="onFoldTab" />
      <el-tabs v-model="activeName" @tab-click="tabsChange">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in tabList" :key="k">
          <div class="content-box">
            <div
              v-for="(subItem, sk) in item.contentList" 
              :key="k + sk"
              class="features"
              :class="{ 'features1': item.name === 'four' }"
            >
              <img v-lazy="subItem.icon" alt="">
              <div class="features-title">{{ subItem.title }}</div>
              <div class="features-description">{{ subItem.description }}</div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    
  </div>
</template>

<script>
import lc1 from '@/assets/images/lc1.png'
import lc2 from '@/assets/images/lc2.png'
import lc3 from '@/assets/images/lc3.png'
import lc4 from '@/assets/images/lc4.png'
import lc5 from '@/assets/images/lc5.png'
import lc6 from '@/assets/images/lc6.png'

import ls1 from '@/assets/images/ls1.png'
import ls2 from '@/assets/images/ls2.png'
import ls3 from '@/assets/images/ls3.png'
import ls4 from '@/assets/images/ls4.png'
import ls5 from '@/assets/images/ls5.png'
import ls6 from '@/assets/images/ls6.png'

import xm1 from '@/assets/images/xm1.png'
import xm2 from '@/assets/images/xm2.png'
import xm3 from '@/assets/images/xm3.png'
import xm4 from '@/assets/images/xm4.png'
import xm5 from '@/assets/images/xm5.png'
import xm6 from '@/assets/images/xm6.png'

import oa1 from '@/assets/images/oa1.png'
import oa2 from '@/assets/images/oa2.png'
import oa3 from '@/assets/images/oa3.png'
import oa4 from '@/assets/images/oa4.png'
import oa5 from '@/assets/images/oa5.png'
import oa6 from '@/assets/images/oa6.png'
import oa7 from '@/assets/images/oa7.png'
import oa8 from '@/assets/images/oa8.png'
import MobileTabFold from '@/components/MobileTabFold/index.vue'
export default {
  components: { MobileTabFold },
  data() {
    return {
      activeName: 'first',
      tabList: [
        {
          name: 'first',
          label: '璞华易研PLM（流程行业）',
          contentList: [
            {
              icon: lc1,
              title: '配方管理',
              description: '结构化配方搭建模式、支持研发视图、生产视图等多样式呈现，配方结构可分层导出，以适配不同使用场景。'
            },
            {
              icon: lc2,
              title: '工艺管理',
              description: '基于自定义模板，可批量快速创建规范化、结构化、数据化的工艺文件，满足产品制造单工序、多工序生产模式。'
            },
            {
              icon: lc3,
              title: '实验管理',
              description: '包含项目计划、交付、资源、变更、报表等核心功能，帮助企业实现项目集的管理，规范项目数据、缩短研发周期。'
            },
            {
              icon: lc4,
              title: '成本管理',
              description: '材料成本分析，配方材料成本自动计算、物料价格走势对比。配方成本预测，物料价格影响利润预测、配方成本虚拟运算、浮动情况可视化比较。'
            },
            {
              icon: lc5,
              title: '知识管理',
              description: '基于物性要求、原料占比检索系统中适配的配方，避免同类产品重复开发，节约研发成本，多种可视化图表，助力快速优选性价比最优、最贴合需求的配方。'
            },
            {
              icon: lc6,
              title: '合规管理',
              description: '支持行业法规、国标、行标、 团标等外来规范性文件的可视化管理、正反查询，指引设计、生产与检测等活动的规范性。'
            }
          ]
        },
        {
          name: 'second',
          label: '璞华易研PLM（离散行业）',
          contentList: [
            {
              icon: ls1,
              title: '数据管理',
              description: '包含物料管理、BOM管理、文档管理、流程管理等PLM的基础功能，可帮助企业实现最基本的数据管理'
            },
            {
              icon: ls2,
              title: '变更管理',
              description: '内置了行业标准的ECR-ECO的工程变更解决方案可根据客户的个性化需求进行业务流程与规则配置'
            },
            {
              icon: ls3,
              title: '项目管理',
              description: '包含项目计划、交付、资源、变更、报表等核心功能，帮助企业实现项目集的管理，规范项目数据、缩短研发周期'
            },
            {
              icon: ls4,
              title: '数据建模',
              description: '全面支持产品生命周期管理中的数据、流程、字段级别的数据建模，以及分层的权限管理'
            },
            {
              icon: ls5,
              title: '在线可视化',
              description: '采用最新的BS架构实现文件的预览，不需要用户客户端安装任何的客户端软件，支持40多种主流文件格式'
            },
            {
              icon: ls6,
              title: '第三方接入',
              description: '通过标准的API接口和Webservice接口，实现PLM的数据同企业的其他业务系统和移动办公系统的深度集成。'
            }
          ]
        },
        
        {
          name: 'third',
          label: '研发项目管理',
          contentList: [
            {
              icon: xm1,
              title: '项目准备',
              description: '立项管理，团队组件、计划编制发布、项目环境管理。'
            },
            {
              icon: xm2,
              title: '项目执行',
              description: '任务管理、进度监控、交付件管理、问题管理、风险管理、评审管理、变更管理、工时管理、资源监控管理等。'
            },
            {
              icon: xm3,
              title: '多级计划管理',
              description: '内嵌主计划、子计划、周计划的整体解决方案，覆盖项目过程中多级计划管理及项目执行追溯的多种业务场景。'
            },
            {
              icon: xm4,
              title: '多维进度管理',
              description: '提供项目清单、项目路线图、任务工作日历及甘特图等多种工具满足不同角色对项目执行进度的组合信息查询。'
            },
            {
              icon: xm5,
              title: '多样化流程配置',
              description: '内嵌自主可配置流程引擎，结合“自定义Jar包+配置”方式满足企业多样化业务流程搭建需求。'
            },
            {
              icon: xm6,
              title: '可视化数据决策支持',
              description: '多种项目仪表盘及统计分析报表为不同角色决策提供数据支撑。'
            }
          ]
        },
        {
          name: 'four',
          label: 'Oracle Agile PLM',
          contentList: [
            {
              icon: oa1,
              title: '产品数据管理',
              description: '企业产品管理及协同，实现产品数据管理、变更协同、图文档统一管理等。'
            },
            {
              icon: oa2,
              title: '设计工具集成',
              description: '实现设计工具与PLM系统的无缝集成，打通数据/图纸传递，提高效率、规范数据'
            },
            {
              icon: oa3,
              title: '成本管理',
              description: '产品寻源及生命周期成本和风险管理，降低企业研发及产品成本。'
            },
            {
              icon: oa4,
              title: '项目管理',
              description: '集成化的产品项目及资源组合化管理，多维度、多部门管理项目产出物。'
            },
            {
              icon: oa5,
              title: '合规管理',
              description: '针对各项标准和规范要求的产品及项目符合性管理。'
            },
            {
              icon: oa6,
              title: '质量管理',
              description: '跨企业及供应链的闭环产品质量管理，保证产品设计质量及可靠性。'
            },
            {
              icon: oa7,
              title: '图纸在线可视化',
              description: '跨全球企业的原始文件协同可视化，实现无纸化电子流程。'
            },
            {
              icon: oa8,
              title: '需求管理',
              description: '支持端到端的市场管理需求流程（需求收集创建、分析、评审确认、分发、实现、验证），实现闭环需求管理'
            }
          ]
        }
      ],
      activeIndexOne: 0,
      timeoutOne: null,
      
    }
  },
  watch: {
    activeName: {
      handler(n) {
      }
    }
  },
  mounted() {
    // this.timeoutModuleOne();
  },
  destroyed() {
    // this.clearTimeoutOne();
  },
  methods: {
    timeoutModuleOne() {
      this.timeoutOne = setInterval(() => {
        if (this.activeIndexOne === this.tabList.length -1) {
          this.activeIndexOne = 0;
        } else {
          this.activeIndexOne++;
        }
        this.activeName = this.tabList[this.activeIndexOne].name
      }, 5000)
    },
    clearTimeoutOne() {
      clearInterval(this.timeoutOne)
    },
    tabsChange(val, aaa) {
      this.activeIndexOne = Number(val.index);
    },
    onFoldTab(name) {
      this.activeName = name
      const idx = this.tabList.findIndex(item => item.name === name)
      if (idx >= 0) this.activeIndexOne = idx
    },
    setActiveTab(name) {
      if (!name) return
      this.onFoldTab(name)
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.characteristic {
  flex-direction: column;
  align-items: center;

  .characteristic-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 4rem;
    padding: 9rem 0 2.4rem;
  }

  .characteristic-description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    padding-bottom: 7.6rem;
  }

  .tab-container {
    width: 100%;
    display: flex;
    justify-content: center;

    ::v-deep .el-tabs {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .el-tabs__nav-wrap::after {
        display: none;
      }
      .el-tabs__header {
        width: calc(192rem - 52rem);
        margin: 0;

        .el-tabs__nav {
          width: 100%;

          .el-tabs__item {
            width: 35rem;
            height: 4.6rem;
            display: inline-flex;
            justify-content: center;
            font-size: 2rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 2rem;
            box-shadow: none;
          }

          .el-tabs__active-bar {
            height: 0.2rem;
            width: 33%;
            background-color: #FB0000;
          }

          .el-tabs__item.is-active, .el-tabs__item:hover {
            color: #FB0000;
          }
        }
      }
      .el-tabs__content {
        width: 100%;
        // border-top: 0.2rem solid #D8E9FE;
        background: url('#{$img}/bj1.png');
        background-size: 100% 100%;
      }
    }

  }

  .content-box {
    position: relative;
    width: calc(192rem - 48rem);
    margin: 4rem auto 8rem;
    overflow: hidden;
    .features {
      float: left;
      width: 44rem;
      height: 24rem;
      background: #FFFFFF;
      box-shadow: 0rem 1.2rem 5rem 0rem rgba(215,222,232,0.72);
      margin: 4rem 2rem 0 2rem;
      text-align: center;
      padding: 2.4rem 6rem 3.1rem;
      &:nth-child(3n) {
        margin-right: 0;
      }
      img {
        width: 7rem;
        height: 7rem;
      }
      &-title {
        margin: 0.9rem 0 1.6rem;
        height: 2.4rem;
        font-size: 2.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 2.4rem;
      }
      &-description {
        height: 6.6rem;
        font-size: 1.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666A77;
        line-height: 2.2rem;
      }
    }
    .features1 {
      width: 32rem;
      &:nth-child(3n) {
        margin-right: 2rem;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .characteristic {
    .characteristic-title {
      width: 100%;
      font-size: 2.4rem;
      line-height: 3.2rem;
      padding: 3.2rem 1.6rem 1.6rem;
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }
    .characteristic-description {
      width: 100%;
      font-size: 1.4rem;
      line-height: 2.2rem;
      padding: 0 1.6rem 3.2rem;
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }
    ::v-deep .el-tabs__header {
      display: none !important;
    }
    .content-box {
      width: 100%;
      margin: 2.4rem auto 4rem;
      padding: 0 1.6rem;
      overflow: visible;
      .features,
      .features1 {
        float: none;
        width: 100%;
        height: auto;
        margin: 0 0 1.6rem;
        padding: 2.4rem 1.6rem;
        overflow: visible;
        img {
          width: 5rem;
          height: 5rem;
        }
      }
      .features-title,
      .features-description {
        height: auto;
        overflow: visible;
        white-space: normal;
        word-break: break-word;
      }
    }
  }
}
</style>
